import { ReactElement } from "react";
import styled from "styled-components";
import InlineHtml from "../InlineHtml";

/** Stock @editorjs/quote data shape. */
interface QuoteData {
  text?: string;
  caption?: string;
  alignment?: string;
}

const Figure = styled.figure`
  margin: 0;
  padding: 4px 0 4px 16px;
  border-left: 3px solid var(--app-color-accent, #2db6b4);
`;

const Text = styled.blockquote<{ $center: boolean }>`
  margin: 0;
  font-size: 17px;
  line-height: 1.5;
  font-style: italic;
  color: var(--app-color-text, #041723);
  text-align: ${({ $center }) => ($center ? "center" : "left")};
`;

const Caption = styled.figcaption`
  margin-top: 6px;
  font-size: 13px;
  color: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.6);
`;

const QuoteBlock = ({ data }: { data: QuoteData }): ReactElement | null => {
  if (!data.text && !data.caption) return null;
  return (
    <Figure>
      <Text $center={data.alignment === "center"}>
        <InlineHtml html={data.text} />
      </Text>
      {data.caption ? (
        <Caption>
          <InlineHtml html={data.caption} />
        </Caption>
      ) : null}
    </Figure>
  );
};

export default QuoteBlock;
